import { CarouselItem as _CarouselItem, CarouselItemProps as _CarouselItemProps } from "reactstrap";

    export const CarouselItem = _CarouselItem;
    export type CarouselItemProps = _CarouselItemProps;
    